// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__g5Q7K","form":"styles_form__2SWL2"};